import { userReviews } from '@/mocks/comments';

export default function UserReviews() {
  // Create 2-column masonry effect on desktop, single column mobile
  const leftCol = userReviews.filter((_, i) => i % 2 === 0);
  const rightCol = userReviews.filter((_, i) => i % 2 === 1);

  return (
    <section className="bg-background-100 py-16 md:py-20" aria-labelledby="reviews-title">
      <div className="w-full px-6 md:px-10">
        <div className="mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            网友口碑
          </span>
          <h2 id="reviews-title" className="text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
            吃瓜群众
            <br />
            真实评价
          </h2>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {/* Left Column */}
          <div className="flex flex-col gap-5 md:gap-6">
            {leftCol.map((review) => (
              <ReviewCard key={review.id} review={review} />
            ))}
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-5 md:gap-6 md:mt-8">
            {rightCol.map((review) => (
              <ReviewCard key={review.id} review={review} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function ReviewCard({ review }: { review: typeof userReviews[0] }) {
  return (
    <article className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
          <img
            src={review.avatar}
            alt={review.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div>
          <strong className="block text-sm font-semibold text-foreground-900">{review.name}</strong>
          <span className="text-xs text-foreground-400">{review.username}</span>
        </div>
      </div>

      {/* Content */}
      <blockquote className="text-sm text-foreground-600 leading-relaxed">
        &ldquo;{review.content}&rdquo;
      </blockquote>

      {/* Stars */}
      <div className="flex items-center gap-0.5 mt-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <i
            key={i}
            className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-200'}`}
          ></i>
        ))}
      </div>
    </article>
  );
}